type Milliseconds = number

export async function pollForConvergentProperties<
  T extends (...args: any[]) => Promise<any>
>(
  cb: T,
  pollWhenPredicate: (props: Awaited<ReturnType<T>>) => boolean,
  timeoutRef?: (timeoutIdRef: number) => void
): Promise<Awaited<ReturnType<T>>> {
  const timeLimit: Milliseconds = 60000
  const waitTime: Milliseconds = 2000
  let timeoutId: number | null = null

  async function handle(
    resolve: (playableState: Awaited<ReturnType<T>>) => void,
    reject: (reason: unknown) => void,
    callCount: number
  ) {
    callCount += 1
    try {
      const values = await cb()
      const isLimitNotReached = callCount * waitTime < timeLimit
      if (isLimitNotReached && pollWhenPredicate(values)) {
        timeoutId = window.setTimeout(
          () => handle(resolve, reject, callCount),
          waitTime
        )
        timeoutRef?.(timeoutId)
      } else {
        if (timeoutId) {
          clearTimeout(timeoutId)
        }
        resolve(values)
      }
    } catch (e) {
      reject(e)
    }
  }

  return new Promise<Awaited<ReturnType<T>>>((resolve, reject) =>
    handle(resolve, reject, 0)
  )
}
